import { Button, ButtonProps, makeStyles, Spinner } from "@fluentui/react-components";
import React from "react";

type S365ButtonProps = ButtonProps & {
  isLoading?: boolean,
  message?: string,
  /**
  * The size of the spinner.
  * @default 'small'
  */
  spinnerSize?: 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge',
}

const useStyles = makeStyles({
  customButton: {
    backgroundColor: '#3EB489 !important', // Base color
    color: 'white !important',
   ':not(:disabled):hover': {
      backgroundColor: '#369B7B !important',
    },
    ':not(:disabled):active': {
      backgroundColor: '#2C8F6E !important',
    },
    ':disabled': {
      backgroundColor: '#A9A9A9 !important', // Greyed out color
      color: '#f0f0f0 !important',
      cursor: 'not-allowed',
      opacity: 0.6,
    },
  },
});

export const S365Button: React.FC<S365ButtonProps> = (props) => {
  const styles = useStyles();

  const [spinnerSize, setSpinnerSize] = React.useState<"tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" | "huge">("tiny");
  const [loadingMessage, setLoadingMessage] = React.useState<string>();

  React.useEffect(() => {
    if (props.spinnerSize) {
      setSpinnerSize(props.spinnerSize);
    } else {
      setSpinnerSize("tiny");
    }
  }, [props.spinnerSize]);


  React.useEffect(() => {
    setLoadingMessage(props.message);
  }, [props.message]);


  return <Button  {...props} className={styles.customButton} style={{ backgroundColor: "#3EB489", color: "white", ...props.style }}>
    {props.isLoading && <Spinner size={spinnerSize} label={loadingMessage} style={{ marginLeft: "var(--spacingHorizontalS)", marginRight: "var(--spacingHorizontalS)" }}></Spinner>}
    {props.children}</Button>

}